/**
 * ShreemTech Universal Admin Panel
 * Copyright (c) 2026 ShreemTech Ltd. All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL — TRADE SECRET
 */

import { apiCall } from "./api-call";
import { Session, SessionUser, UserRole } from "../types";
import { LoginParams, AuthResult } from "../mocks/auth-mock";

export const realAuthClient = {
  login: async (params: LoginParams): Promise<AuthResult> => {
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: params.username, password: params.password }),
      });
      const data = await res.json().catch(() => ({})) as Record<string, unknown>;
      if (!res.ok) {
        return { success: false, error: (data.error as string) ?? "Login failed" };
      }
      const user = data.user as SessionUser;
      return {
        success: true,
        session: {
          user,
          accessToken: data.accessToken as string,
          expiresAt: data.expiresAt as number,
        },
      };
    } catch {
      return { success: false, error: "Authentication service unavailable" };
    }
  },

  logout: () => apiCall<void>("/api/auth/logout", { method: "POST" }),

  validateToken: (token: string) =>
    apiCall<SessionUser | null>("/api/auth/validate", {
      method: "POST",
      body: JSON.stringify({ token }),
    }),

  getSession: (): Session | null => {
    if (typeof document === "undefined") return null;
    const cookie = document.cookie.split(";").find((c) => c.trim().startsWith("shreem-session="));
    if (!cookie) return null;
    try {
      return JSON.parse(decodeURIComponent(cookie.split("=")[1])) as Session;
    } catch {
      return null;
    }
  },

  setSession: (session: Session): void => {
    if (typeof document === "undefined") return;
    const maxAge = Math.floor((session.expiresAt - Date.now()) / 1000);
    document.cookie = `shreem-session=${encodeURIComponent(JSON.stringify(session))}; Max-Age=${maxAge}; path=/; SameSite=Strict`;
  },

  decodeRole: (_token: string): UserRole | null => null,
};
